const filterSelectionTag = () => {
  const selectedColors = []
  const selectedAvailabilities = []

  document
    .querySelectorAll('.mobile-facets__checkbox[name*="color"]:checked')
    .forEach(function (checkbox) {
      selectedColors.push(checkbox.value)
    })

  document
    .querySelectorAll('.mobile-facets__checkbox[name*="availability"]:checked')
    .forEach(function (checkbox) {
      const label = checkbox.closest("label")
      const availabilityText = label
        .querySelector(".facet-checkbox__text-label")
        .innerText.trim()
      selectedAvailabilities.push(availabilityText)
    })

  dataLayer.push({
    event: "advanced_filter_selection",
    filter_color: selectedColors,
    filter_availability: selectedAvailabilities,
  })
}
